export const SLEEVE_WEIGHT_TONS_PER_METER = {
    WHEAT: 4.2,
}